<template>
  <div :class="classes">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'MTagList',
  props: {
    wrap: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    xs: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return [
        'm-tag-list',
        this.small ? '-small' : '',
        this.xs ? '-xs' : '',
        this.wrap ? '-wrap' : '',
      ];
    },
  },
};
</script>

<style lang="scss" type="text/scss">
  .m-tag-list {
    display: flex;
    flex-grow: 1;
    min-width: 0;

    .m-tag {
      flex-shrink: 0;
      margin: 0 .6rem .5rem 0;

      .m-tag {
        margin: 0;
      }
    }

    &.-wrap {
      flex-wrap: wrap;

      .m-tag {
        min-width: 0;
        max-width: 100%;
      }
    }

    &.-small {
      .m-tag {
        margin: 0 .5rem .4rem 0;
      }
    }

    &.-xs {
      .m-tag {
        margin: 0 .4rem .3rem 0;
      }
    }
  }

  .m-tag-list > *:last-child {
    .m-tag {
      min-width: 0;
      max-width: 100%;
      margin-right: 0;
    }
  }
</style>
